import { GetCompanyResponse } from '@Common/types/bo_external/companies';

import { companiesTranslations as companiesTranslationsEn } from '@I18n/en/companies';

export const companiesTranslations = {
  fields: {
    id: 'ID Entreprise',
    street: 'Rue',
    postalcode: 'Code postal',
    city: 'Ville',
    country: 'Pays de résidence',
    name: 'Raison sociale',
    legal_form: 'Forme juridique',
    headcount: 'Effectif salarié annuel',
    siret: 'Siret',
    registration_date: "Date d'enregistrement",
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
    logo_url: "Logo de l'entreprise",
    start_fiscal_year: "Fin d'exercice (JJ/MM)",
    naf_code: 'Code NAF/APE',
    previous_naf_code: 'Ancien code NAF/APE',
    rcs_location: 'Lieu d’immatriculation au RCS',
    collective_agreement_code: 'Identifiant Des Conventions Collectives (IDCC)',
    collective_agreement_name: 'Nom des Conventions Collectives',
    has_documents: 'Documents',
    contacts: 'Contacts',
    domains: 'Email domains',
    mailing_street: 'Rue',
    mailing_postalcode: 'Code postal',
    mailing_city: 'Ville',
    mailing_country: 'Pays de résidence',
    billing_street: 'Rue',
    billing_postalcode: 'Code postal',
    billing_city: 'Ville',
    billing_country: 'Pays de résidence',
    retirement_age: 'Âge de la retraite',
    international_identifier: 'Identifiant International',
    is_international: 'Entreprise internationale',
    has_indirect_management_contract: 'Contrat de gestion indirect',
    has_payment_methods: 'Dispose de moyens de paiement',
    has_ccb: "Dispose d'un CCB",
  } satisfies Record<keyof GetCompanyResponse, string>,
  tabs: {
    details: {
      label: 'Profil entreprise',
      headers: {
        financial_information: 'Information financière',
        address: 'Adresse du siège social',
        mailing_address: 'Adresse de correspondance',
        billing_address: 'Adresse de facturation',
      },
    },
    fees: {
      label: 'Frais',
    },
    representative: {
      label: 'Représentants',
      headers: {
        legal_representative: 'Représentant légal',
        business_correspondent: 'Correspondant entreprise',
      },
      fields: {
        id: 'ID',
        role: "Fonction dans l'entreprise",
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        landline: 'Téléphone fixe',
        phone_number: 'Téléphone mobile',
        is_business_correspondent: 'Est un correspondant entreprise',
      },
    },
    admins: {
      label: 'Correspondants',
    },
    plans: {
      label: 'Plans',
    },
    documents: {
      label: 'Documents',
    },
    dashboard: {
      label: 'Tableau de bord',
    },
    payment_methods: {
      label: 'Informations de paiement',
    },
  },
  choices: {
    created: 'Créé',
    in_review: 'En cours de révision',
    verified: 'KYB Complété',
    denied: 'Refusé',
    resigned: 'Démissionné',
  },
  dashboard: {
    active_campaigns: {
      title: {
        singular: 'Opération active',
        plural: 'Opérations actives',
      },
      participation: 'Participation',
      operation_id: 'ID opération',
      status: 'Statut',
      amount: 'Montant',
      in_progress: 'En cours',
      answer_rate: 'Taux de réponse',
      of_affiliates_answered: 'des affiliés ont répondu',
      no_active_campaigns: 'Aucune campagne active',
      create: 'Créer',
    },
    titles: {
      matching_contribution: 'Abondement',
      matching_contribution_details: "Détails de l'abondement ",
      savings: 'Épargne',
      latest_documents: 'Documents récents',
      affiliates: "Nombre d'affiliés depuis le début de l'année qui ont",
    },
    see_all: 'Voir tout',
    matching_contribution: {
      data_for_year: "Répartition de l'abondement pour %{year}",
      paid: 'Déjà investi',
      awaiting_company: "En cours d'investissement",
      not_distributed: 'Non consommé',
      potential_payout: "Montant d'abondement total",
      topped_limit: "Adhérent ayant dépassé leur limite d'abondement",
      optimised: 'Adhérent ayant optimisé leurs abondements',
      not_used: "Adhérent n'ayant pas utilisé leurs abondements",
    },
    savings: {
      per_product: 'Par produit',
      per_fund: 'Par fonds',
      total_savings: 'Épargne totale',
      other: 'Autres',
    },
    affiliates: {
      made_arbitrage: 'Fait un arbitrage',
      made_voluntary_deposit: 'Fait un versement volontaire',
    },
  },
} satisfies typeof companiesTranslationsEn;
